var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.127,
    height: 48.012,
    viewBox: "0 0 71.127 48.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    className: "cls-1",
    d: "M.072,47.828V8.321q0-.069.206-1.3L23.529,26.908.346,49.2a5.813,5.813,0,0,1-.274-1.372ZM3.159,4.274a2.956,2.956,0,0,1,1.166-.206H66.946a3.884,3.884,0,0,1,1.235.206L44.861,24.233,41.774,26.7l-6.1,5.007-6.1-5.007-3.087-2.469Zm.069,47.6L26.616,29.446l9.054,7.339,9.054-7.339L68.112,51.875a3.293,3.293,0,0,1-1.166.206H4.325a3.107,3.107,0,0,1-1.1-.206ZM47.81,26.908,70.993,7.017a4.094,4.094,0,0,1,.206,1.3V47.828a5.257,5.257,0,0,1-.206,1.372Z",
    transform: "translate(-0.072 -4.068)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.6a7091e66987cfa9f14b24784a156602.svg";
export { ForwardRef as ReactComponent };